import { IndentedFormFieldContainer } from '@ui-components/global/FormStyling'
import { ReactNode, RefAttributes } from 'react'

import { ErrorAndDescriptionRow } from '../common/ErrorAndDescriptionRow'
import { Label } from '../dataDisplay/Label'
import {
  ErrorSpacerWithReservedSpace,
  FlexColumnContainer,
  FlexRowContainer,
  NarrowInputFieldWrapper,
} from '../global/CommonStyling'
import { FormTextInputProps } from '../global/ComponentProps'
import { parseComponentId } from '../utilities/helpers'
import { TextInputField } from './primitive/TextFields'

export const FormTextInput = (props: FormTextInputProps & RefAttributes<HTMLInputElement>): ReactNode => {
  const { id, name, renderPrefix = () => '', readOnly, disabled, error, additionalDescription } = props
  const { children, ...withoutChildren } = props

  const overriddenId = parseComponentId(name, id)

  const errorAndDescriptionRow = (
    <ErrorAndDescriptionRow error={error} id={overriddenId} description={additionalDescription} />
  )

  return (
    <div data-testid={overriddenId + '-wrapper'}>
      <NarrowInputFieldWrapper $readonly={readOnly} $disabled={disabled}>
        {props.label && (
          <Label isRequired={props.required} label={props.label} id={overriddenId} description={props.description} />
        )}
        <FlexColumnContainer>
          <FlexRowContainer>
            {renderPrefix({})}
            <TextInputField
              {...withoutChildren}
              readOnly={readOnly}
              disabled={disabled}
              id={overriddenId}
              error={error}
            />
          </FlexRowContainer>
          {/* IndentedFormFieldContainer handles spacing for error and description row when rendered */}
          {children ? (
            errorAndDescriptionRow
          ) : (
            <ErrorSpacerWithReservedSpace>{errorAndDescriptionRow}</ErrorSpacerWithReservedSpace>
          )}
        </FlexColumnContainer>
      </NarrowInputFieldWrapper>
      {children && <IndentedFormFieldContainer>{children}</IndentedFormFieldContainer>}
    </div>
  )
}
